import { editHistoryMenuItems } from 'Components/HistoryRowControls/EditHistory/EditHistoryDialog';
import HistoryRowVerticalItem from 'Components/HistoryRowVerticalItem';
import HistorySection from 'Components/HistorySection';
import * as React from 'react';
import { formatPartialDate } from 'Utility/date';
import { filterDocumentsByType, sortDocumentsDescending } from 'Utility/documentHandling';
import { isNil } from 'Utility/ramdaReplacement';
import { newButton } from '../../../../utils/functions';

import type { IHistoryContext } from 'Containers/FormContextHandler';

const DEFAULT_DOCUMENTS: IDocumentWithTypeV2<'msSymptoms'>[] = [];
const MsSymptoms = ({
  documents = DEFAULT_DOCUMENTS,
  startEdit,
  fm,
}: IHistoryContext<IDocumentWithTypeV2<'msSymptoms'>>): React.JSX.Element => {
  const msSymptoms = filterDocumentsByType(documents, ['msSymptoms']).sort(sortDocumentsDescending).at(0);

  return (
    <HistorySection
      headerText={fm('diagnosis.msEarlySymption')}
      hasHistoryRows={false}
      newButton={
        startEdit
          ? newButton(
              'msSymptoms',
              startEdit(msSymptoms ?? {}, 'msSymptoms'),
              'general.edit',
              undefined,
              true,
              !isNil((msSymptoms ?? {})._lockedFor),
              undefined,
              undefined,
              msSymptoms,
            )
          : undefined
      }
      menuItems={editHistoryMenuItems(msSymptoms)}
    >
      <React.Fragment>
        <HistoryRowVerticalItem
          header={fm('diagnosis.symptomOnsetDate')}
          value={
            msSymptoms?.symptomOnsetDate ? (
              <div style={{ display: 'flex', flexDirection: 'column' }}>
                {formatPartialDate(msSymptoms.symptomOnsetDate)}
              </div>
            ) : (
              ' - '
            )
          }
        />

        <HistoryRowVerticalItem
          header={fm('diagnosis.msSymptom.title')}
          value={
            msSymptoms?.msSymptoms?.length
              ? msSymptoms.msSymptoms.map(symptom => fm('diagnosis.msSymptom.opts.' + symptom))
              : ' - '
          }
        />

        <HistoryRowVerticalItem
          header={fm('diagnosis.msSymptomLevel.title')}
          value={
            msSymptoms?.msSymptomLevel?.length
              ? msSymptoms.msSymptomLevel.map(symptomLevel => fm('diagnosis.msSymptomLevel.opts.' + symptomLevel))
              : ' - '
          }
        />

        <HistoryRowVerticalItem
          header={fm('diagnosis.msOriginOfInformation.title')}
          value={
            msSymptoms?.msOriginOfInformation
              ? fm('diagnosis.msOriginOfInformation.opts.' + msSymptoms.msOriginOfInformation)
              : ' - '
          }
        />

        <HistoryRowVerticalItem
          header={fm('diagnosis.msWasCortisoneGiven')}
          value={
            msSymptoms?.msWasCortisoneGiven
              ? fm('diagnosis.opts.yesNoUnknown.' + msSymptoms.msWasCortisoneGiven)
              : ' - '
          }
        />

        {msSymptoms?.msWasCortisoneGiven === 'yes' && (
          <HistoryRowVerticalItem
            header={fm('diagnosis.msCortisoneMedicationRecorded')}
            value={
              msSymptoms.msCortisoneMedicationRecorded
                ? fm('diagnosis.opts.yesNoUnknown.' + msSymptoms.msCortisoneMedicationRecorded)
                : '-'
            }
          />
        )}

        <HistoryRowVerticalItem
          header={fm('diagnosis.msWasPlasmaGiven')}
          value={
            msSymptoms?.msWasPlasmaGiven ? fm('diagnosis.opts.yesNoUnknown.' + msSymptoms.msWasPlasmaGiven) : ' - '
          }
        />
      </React.Fragment>
    </HistorySection>
  );
};

export default MsSymptoms;
